export const buildBriefReaderMatterWindowName = (matterId) => {
  if (matterId == null || matterId === "") return null;
  return `dms-matter-${matterId}`;
};

export const claimBriefReaderMatterWindowName = (matterId) => {
  const name = buildBriefReaderMatterWindowName(matterId);
  if (!name || typeof window === "undefined") return () => {};
  const previousName = window.name || "";
  window.name = name;
  return () => {
    if (window.name === name) {
      window.name = previousName;
    }
  };
};

export const openBriefCitationInMatterWindow = ({ matterId, target } = {}) => {
  if (!target || typeof window === "undefined" || typeof window.open !== "function") {
    return false;
  }
  const name = buildBriefReaderMatterWindowName(matterId) || "_blank";
  return Boolean(window.open(target, name));
};
